
// React
import * as React from 'react';
// UI
import { Typography, Paper, Button} from '@material-ui/core';
// Redux
import { Dispatch, Action } from 'redux';
import { connect } from 'react-redux';
import { IAppState, fullArchiveDownloadObsrecOperations } from '../../redux/modules';
import { SiteInfoListState } from '../../redux/modules/siteInfoList';
import { FullArchiveDownloadObsrecState } from '../../redux/modules/fullArchiveDownloadObsrec';
// Util
import * as H from 'history';
import * as moment from 'moment';
import { CloseBackButton } from '../parts/CloseBackButton';
import { download } from '../../utils';
// TypeScript
import { SiteInfo } from '../../models/SiteInfo';

const styles = {
  contentBase: {
    padding: '10px',
    marginBottom: '20px'
  },
  area: {
    marginBottom: '30px'
  }
};

interface OwnProps {
  match: any; // withRouterにより設定される
  listSiteInfo: () => void;
  history: H.History;
  sites: SiteInfoListState;
  getStatus: (params: {koujiBangou: string}) => any;
  createArchive: (params: {koujiBangou: string}) => any;
  status: FullArchiveDownloadObsrecState;
}
interface OwnState {
  // 工事現場の情報
  site: SiteInfo | undefined;
  // ダウンロード要求ボタンの使用可否
  requestButtonDisabled: boolean;
};

class FullArchiveDownloadObsrecPage extends React.Component<OwnProps, OwnState>{
  // アーカイブ作成状態を定期的に取得するタイマー
  private archiveStatusTimerId;
  constructor(props: OwnProps) {
    super(props);
    this.state = {
      site: undefined,
      requestButtonDisabled: false
    };
  }
  componentDidMount() {
    // このページの工事番号
    const koujiBangou = this.props.match.params.koujibangou;
    // このページの工事情報
    const siteInfo = this.props.sites.items.find((item) => (item.koujiBangou === koujiBangou));
    // // 工事情報が不正な場合はリストに戻る
    // if (!siteInfo) {
    //   this.props.history.replace('/sitelist');
    //   return ;
    // }
    this.setState({ site: siteInfo });
    this.props.getStatus({ koujiBangou });
    // 状態取得タイマー設定
    this.archiveStatusTimerId = setInterval(() => {
      // アーカイブの作成状態を取得する
      this.props.getStatus({ koujiBangou });
    }, 10000);
  }
  componentWillUnmount() {
    if (this.archiveStatusTimerId) {
      clearInterval(this.archiveStatusTimerId);
      this.archiveStatusTimerId = '';
    }
  }

  // DynamoDBのTTLは設定時刻以降のどこかのタイミングで削除されるという仕様であり、
  // ダウンロード要求時に削除されている可能性があるためTTLを現在時刻と比較する
  // TTLが現在時刻より後と、TTLが未設定の場合はtrue
  isInLive() {
    // データがない場合はfalse
    if (!this.props.status.item.status) {
      return false;
    }
    // ttlが設定されていない場合は常にfalse
    if (!this.props.status.item.ttl) {
      return true;
    }
    const now = moment();
    const ttlMoment = moment(this.props.status.item.ttl * 1000);
    return now.isSameOrBefore(ttlMoment);
  }
  isCreated() {
    // データの有効期限が切れていればfalse
    if (!this.isInLive()) {
      return false;
    }
    return (this.props.status.item.status === 'created');
  }
  isCreating() {
    // データの有効期限が切れていればfalse
    if (!this.isInLive()) {
      return false;
    }
    return (this.props.status.item.status === 'creating');
  }
  createArchive() {
    // ダウンロードリクエストは非同期でするに終わってしまうので、
    // 一定時間ボタンを使用不可にする
    this.setState({ requestButtonDisabled: true });
    this.props.createArchive({
      koujiBangou: this.props.match.params.koujibangou
    });
    setTimeout(() => this.setState({ requestButtonDisabled: false }), 5000);
  }
  render() {
    const site = this.state.site || new SiteInfo();
    // このページの工事番号
    const koujiBangou = this.props.match.params.koujibangou;

    const created = this.isCreated();
    const creating = this.isCreating();
    const statusStr = created
          ? '作成済み'
          : creating
              ? '作成中'
              : '未作成' ;
    return (
      <div>
        <Paper style={{ padding: '10px' }}>
          <Typography variant="h4" style={{ marginBottom: '10px' }}>
            {koujiBangou} : {site.name}
          </Typography>
          <Paper
            style={styles.contentBase}
          >
            <Typography variant="h6">観察記録の一括ダウンロード</Typography>
            <div style={styles.area}>
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  this.createArchive();
                }}
                disabled={this.state.requestButtonDisabled}
              >
                ファイル作成を要求
              </Button>
            </div>
            <div style={styles.area}>
              <Typography variant="h6">ファイル作成状況</Typography>
              <Typography variant="h5">{statusStr}</Typography>
              {
                (created && this.props.status.item.ttl)
                  ? (<Typography variant="body2">{moment(this.props.status.item.ttl * 1000).format('M/D HH:mm')}までにダウンロードしてください。</Typography>)
                  : null
              }
            </div>
            <div style={styles.area}>
              <Button
                variant="contained"
                color="secondary"
                disabled={!created}
                fullWidth
                onClick={() => {
                  download(
                    this.props.status.item.bucket,
                    this.props.status.item.fileKey
                  );
                }}
              >
                ダウンロード
              </Button>
            </div>
          </Paper>
        </Paper>
        <CloseBackButton history={this.props.history} />
      </div>
    );
  }
}

function mapDispatchToProps(dispatch: Dispatch<Action<any>>) {
  return {
    getStatus: ({ koujiBangou }) => {
      fullArchiveDownloadObsrecOperations.getStatus({ koujiBangou })(dispatch);
    },
    createArchive: ({ koujiBangou }) => {
      fullArchiveDownloadObsrecOperations.createArchive({ koujiBangou })(dispatch);
    }
  };
}

function mapStateToProps(appState: IAppState) {
  return {
    sites: appState.siteInfoList,
    status: appState.fullArchiveDownloadObsrec,
    user: appState.user
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FullArchiveDownloadObsrecPage);





// WEBPACK FOOTER //
// ./src/components/obsrec/FullArchiveDownloadObsrecPage.tsx